import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-main-footer',
    templateUrl: './main-footer.component.html',
    styleUrls: ['./main-footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MainFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
